import { device } from "./Breakpoints";
import styled from "@emotion/styled";
import { Form } from "formik";

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
